











































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import { maskDate } from '@/utils/common'
import RecebimentoStore from '@/components/Recebimento/Store/RecebimentoStore'
import ModalAddProfissionaisEquipeMedica from './ModalAddProfissionaisEquipeMedica.vue'

@Component
export default class ModalTabelaRegrasGerenciamentoEquipes extends Vue {
  readyState = false
  loadTabela = false
  loadProfissionais = false
  prestadorSearch = ''

  get getRecebimentoStore() { return getModule(RecebimentoStore, this.$store) }

  get getProfissionais() { return this.getRecebimentoStore.profissionaisTable }

  get loadingProfissionais() { return this.loadProfissionais }
  set loadingProfissionais(value: boolean) { this.loadProfissionais = value }

  get loadingTabela() { return this.loadTabela }
  set loadingTabela(value: boolean) { this.loadTabela = value }

  get getGestoresTableHeader() {
    return [
      { text: 'Profissional', class: 'table-headers', align: 'left', value: 'profissionalNome' },
      { text: 'Criado por', class: 'table-headers', align: 'left', value: 'createdByNome' },
      { text: 'Criado em', class: 'table-headers', align: 'left', value: 'createdOn' },
    ]
  }

  get showModal() {
    return this.getRecebimentoStore.modalTabelaRegrasGerenciamentoEquipes
  }

  set showModal(value: boolean) {
    this.getRecebimentoStore.setModalTabelaRegrasGerenciamentoEquipes(value)
  }

  maskDate(date: string) {
    return maskDate(date)
  }

  async showModalAddTabelaProfissionais() {
    this.loadingProfissionais = true
    await this.getRecebimentoStore.getProfissionais()
    this.getRecebimentoStore.setModalAddProfissional(true)
    this.loadingProfissionais = false
  }

  @Watch('showModal')
  onChangeShowModalPrestadores(value: boolean) {
    if (!value) {
      this.prestadorSearch = ''
    }
  }
}
